import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-payment-success',
  imports: [
    RouterModule,
    UiModule
  ],
  templateUrl: './payment-success.html',
  styleUrl: './payment-success.css',
})
export class PaymentSuccess {
  readonly router=inject(Router);
}
